
import React from "react"
import styled from "styled-components"
import {Container, ExternalLink, wiggleAnimation, SlideIn, AnimationText} from "../components/DesignSystem"
import { useInView } from 'react-intersection-observer';

const FooterWrapper = styled.footer`
    padding: var(--stackSpacingL) 0 var(--stackSpacingXXXL) 0;
    font-size: var(--fontSizeXXXL);
    line-height: 1.2;

    header {
      font-weight: var(--extraBold);
    }
    .email {
      font-size: var(--fontSizeXXL);
      margin-top: 1.25rem;
    }

    span {
      font-size: var(--fontSizeXXXL);
      margin-right: 1rem;
      margin-bottom: 1.25rem;
      display: inline-block;
      animation-name: ${wiggleAnimation};
      animation-duration: 1s;
      animation-iteration-count: infinite; 
    }

`;
const introRender = (introVerbiage, totalDelay = 0, trigger = true) => {
  let n = 1;
  return introVerbiage.map((sen, iS) => {
      return (
          <div key={iS}>
          {sen.split(' ').map((word, iW) => {
              n++;
              return (
                  <React.Fragment key={iW}><AnimationText trigger={trigger} duration={0.5} delay={totalDelay + 0.1*n}>{word}</AnimationText> </React.Fragment>
              )
          })}
          </div>
      )
  });
}

const Footer = (props) => {
    const [ref, inView] = useInView({ threshold: 0.4 });
    const footerSentence = [
      'Got a project',
      'want a hand'
    ];

    return (
      <FooterWrapper>
        <Container>
        <div ref={ref}>
   
          <header>
          <SlideIn trigger={inView} delay="0"><span rel="img">💬</span></SlideIn>

          {introRender(footerSentence, 0.2, inView)}
        
          </header>
          <div className="email">
          <SlideIn trigger={inView} delay="0.7" duration="0.4" distance="40px">Send me an email via:</SlideIn>
          <SlideIn trigger={inView} delay="0.8" duration="0.4" distance="40px"><ExternalLink href="mailto:audtuan@gmail.com" name="audtuan@gmail.com"></ExternalLink></SlideIn>
          </div>
          {/* <hr />
          Copyright © {(new Date()).getFullYear()} Tuan Au Duong. */}
        </div>
        </Container>
      </FooterWrapper>
    )
  }

  export default Footer;